import { Control, UseFormGetValues, UseFormSetValue } from "react-hook-form";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
import APIS from "../../constant/EndPoint";
import { classNames } from "../../utils/classNames";
import DateRangePicker from "../Reusable/DateRangerPicker";
import { IFilterReport } from "../../types/interface";
import { useState } from "react";
import ComboboxInput from "../Reusable/AttendanceComboBox";

interface Props {
  setValue: UseFormSetValue<IFilterReport>;
  getValues: UseFormGetValues<IFilterReport>;
  reset: () => void;
  control: Control<IFilterReport, any>;
  clearErrors: (name?: any) => void;
}

const Filter = ({
  setValue,
  getValues,
  reset,
  control,
  clearErrors,
}: Props) => {
  // const [isStaff, setIsStaff] = useState(true);
  return (
    <>
      <div className={tw`grid grid-cols-2 gap-x-4 mx-4`}>
        {/* <div className={tw`col-span-2 flex flex-col`}>
          <label className={tw`font-medium mb-1`}>Employee Type</label>

          <button
            type="button"
            onClick={() => {
              setIsStaff((prev) => !prev);
              setValue("name", null);
            }}
            className={tw`
        px-3 py-2 border mt-2 focus:outline-none
        ${isStaff ? "bg-blue-600 text-white" : "bg-gray-200 text-black"}
      `}
          >
            {isStaff ? "Staff" : "Other Employee"}
          </button>
        </div> */}

        <div className={tw``}>
          <ComboboxInput
            url={APIS.STAFF_INFO}
            queryKey={"staff-list"}
            name={"name"}
            label={"Select Employee"}
            props={{}}
            setValue={setValue}
            placeholder={"Select Employee"}
            getValues={getValues}
            clearErrors={clearErrors}
          />
        </div>

        <div className={tw``}>
          <DateRangePicker
            label={"Select Date Range"}
            setValue={setValue}
            name={"created__range"}
            getValues={getValues}
          />
        </div>
      </div>
      <button className={tw`absolute -top-5 right-5`} onClick={() => reset()}>
        Reset
      </button>
    </>
  );
};

export default Filter;
